import PropTypes from 'prop-types';
import React from 'react';

import styles from './WorkPlaceRetirementLink.module.scss';

const WorkPlaceRetirementLink = ({ displayMode = 'body' }) => {
  return (
    <div
      className={`${styles['retirement-link-container']} ${styles[displayMode]}`}
    >
      <a
        href="https://www.troweprice.com/rps/rws/account/participant/contactus.otc"
        rel="noopener noreferrer"
        target="_blank"
      >
        Send a message
      </a>{' '}
      for your workplace retirement account.
    </div>
  );
};

WorkPlaceRetirementLink.propTypes = {
  /*
    Used for styling link container based on it's use
    (within the tab or content body), especially in responsive mode.
  */
  displayMode: PropTypes.oneOf(['body', 'tab'])
};

export default WorkPlaceRetirementLink;
